import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useSetPrefs } from '@games/api';
import { HelmetTitle } from '../helmet';
import messages from 'intl/messages';
import { PrefsForm, PrefsValues } from './PrefsForm';
import { selectAuthUser } from './auth-slice';

export const PrefsPage: React.FC = () => {
  const me = useSelector(selectAuthUser);
  const [{ loading, data }, setPrefs] = useSetPrefs();
  const { formatMessage } = useIntl();

  const submit = React.useCallback((data: PrefsValues) => {
    setPrefs({ data });
  }, [setPrefs]);

  const initialValues =
    me ?
      {
        lang: me.lang || 'en',
        nonogramSize: me.nonogramSize || 5,
      }
    :
      undefined;
  return (
    <div className='container mx-auto'>
      <HelmetTitle message={formatMessage(messages.settings)} />
      <h2 className='text-center text-2xl mb-4 font-bold'>
        <FormattedMessage {...messages.settings} />
      </h2>
      <PrefsForm
        onSubmit={submit}
        initialValues={initialValues}
        loading={loading}
      />
      {data && data.success && (
        <div className='mt-3 alert alert-success' role='alert'>
          <FormattedMessage {...messages.settingsUpdated} />
        </div>
      )}
    </div>
  );
};
